<template>
  <div class="form-config-list main-content-cj h-100 mh-100">
    <b-container class="d-flex flex-column h-100 mh-100">
      <div class="main-header">
        <b-row class="align-items-center">
          <b-col cols="12" md="6" class="d-flex align-content-center">
            <span class="title">Prontuários</span>
          </b-col>
          <b-col cols="12" md="6" v-if="canAdd">
            <b-row class="d-flex align-items-center justify-content-end" >
              <b-col cols="auto">
                <router-link tag="a" class="btn btn-primary btn-sm" to="/prontuarios/novo-formulario"><i class="far fa-dot-circle"></i> Adicionar novo formulário</router-link>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <hr class="mb-0">
      </div>
      <div class="box-container">
        <b-row>
          <b-col cols="6" md="3" v-for="form in forms" :key="form.id">
            <router-link tag="div" :to="'/prontuarios/' + form.id" class="box-cj pointer">
              <div class="content text-center">
                <span class="icon" :class="{ 'enabled': form.enabled}">
                  .{{ getExtension(form.name) }}
                </span>
                <p class="sub-title mb-0">{{ form.name }}</p>
                <p class="status mb-0" v-if="form.enabled"><i class="far fa-check-circle enabled"></i> Utilizando</p>
                <p class="status mb-0" v-else>Desabilitado</p>
              </div>
            </router-link>
          </b-col>
        </b-row>
        <hr>
        <p class="title mt-4 mb-3">Modelos disponíveis</p>
        <b-row class="mb-5">
          <b-col cols="6" md="3" v-for="(model, index) in models" :key="index">
            <div class="box-cj pointer pointer" @click="showModel(model)">
              <div class="content text-center">
                <span class="icon">
                  .{{ getExtension(model.name) }}
                </span>
                <p class="sub-title mb-0">{{ model.name }}</p>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-modal id="model-modal" class="model-modal" :modalClass="'model-modal'" size="lg" @hidden="resetModelModal">
        <template slot="modal-header" v-if="modelSelected != null">
          {{ modelSelected.name }}
        </template>
        <template slot="default" v-if="modelSelected != null">
          <b-row v-if="modelSelected.fields.length > 0">
            <b-col v-for="field in modelSelected.fields" :key="field.id" :md="field.cols" :order="field.order" class="mb-2">
              <FormField :field="field" :readonly="true"></FormField>
            </b-col>
          </b-row>
        </template>
        <template slot="modal-footer">
          <b-button size="sm" @click="$bvModal.hide('model-modal')">Fechar</b-button>
          <b-button size="sm" variant="primary" @click="useSelectedModel" v-if="canAdd">Usar modelo</b-button>
          <b-button size="sm" variant="danger" @click="deleteSelectedModel" v-if="canRemove && modelSelected != null && modelSelected.id != null">Remover modelo</b-button>
        </template>
      </b-modal>
    </b-container>
  </div>
</template>

<script>

  export default {
    data() {
      return {
        leavingPage: false,
        canSee: true,
        canAdd: true,
        canEdit: true,
        canRemove: true,
        canPerformAction: true,

        forms: [],
        models: [],

        modelSelected: null,
        defaultModels: [
          {
            name: 'Anamnese',
            enabled: true,
            fields: [
              {
                id: null,
                type: 'short-text',
                name: 'Queixa Principal',
                order: 0,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 12,
                rows: 5
              },
              {
                id: null,
                type: 'long-text',
                name: 'História da moléstia atual',
                order: 1,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 12,
                rows: 5
              },
              {
                id: null,
                type: 'long-text',
                name: 'Sistema respiratório',
                order: 2,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 12,
                rows: 5
              },
              {
                id: null,
                type: 'long-text',
                name: 'Sistema cardiovascular',
                order: 3,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 12,
                rows: 5
              },
              {
                id: null,
                type: 'long-text',
                name: 'Sistema digestório',
                order: 4,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 12,
                rows: 5
              },
              {
                id: null,
                type: 'long-text',
                name: 'Medicações em uso',
                order: 5,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 12,
                rows: 5
              },
              {
                id: null,
                type: 'long-text',
                name: 'Hospitalizações, acidentes, traumatismos e cirurgias',
                order: 6,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 12,
                rows: 5
              },
              {
                id: null,
                type: 'long-text',
                name: 'Alergias',
                order: 7,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 12,
                rows: 5
              },
              {
                id: null,
                type: 'boolean',
                name: 'Hepatite',
                order: 8,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 6,
                rows: 5
              },
              {
                id: null,
                type: 'boolean',
                name: 'Gravidez',
                order: 9,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 6,
                rows: 5
              },
              {
                id: null,
                type: 'boolean',
                name: 'Diabetes',
                order: 10,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 6,
                rows: 5
              },
              {
                id: null,
                type: 'boolean',
                name: 'Problemas de cicatrização',
                order: 11,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 6,
                rows: 5
              },
              {
                id: null,
                type: 'multiple-choice',
                name: 'Hábitos',
                order: 12,
                required: false,
                options: 'Etilismo;Tabagismo',
                has_default_value: false,
                default_value: '',
                cols: 6,
                rows: 5
              },
              {
                id: null,
                type: 'list',
                name: 'Estilo de vida',
                order: 13,
                required: false,
                options: 'Sedentário;Atividade física reguar',
                has_default_value: false,
                default_value: '',
                cols: 6,
                rows: 5
              },
            ]
          },
          {
            name: 'Anamnese Psicológica',
            enabled: true,
            fields: [
              {
                id: null,
                type: 'short-text',
                name: 'Profissão',
                order: 0,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 4,
                rows: 5
              },
              {
                id: null,
                type: 'short-text',
                name: 'Religião',
                order: 1,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 4,
                rows: 5
              },
              {
                id: null,
                type: 'short-text',
                name: 'Escolaridade',
                order: 2,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 4,
                rows: 5
              },
              {
                id: null,
                type: 'short-text',
                name: 'Nome do Pai',
                order: 4,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 12,
                rows: 5
              },
              {
                id: null,
                type: 'short-text',
                name: 'Profissão do Pai',
                order: 5,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 4,
                rows: 5
              },
              {
                id: null,
                type: 'short-text',
                name: 'Idade do Pai',
                order: 6,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 4,
                rows: 5
              },
              {
                id: null,
                type: 'short-text',
                name: 'Escolaridade do Pai',
                order: 7,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 4,
                rows: 5
              },
              {
                id: null,
                type: 'short-text',
                name: 'Nome da Mãe',
                order: 8,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 12,
                rows: 5
              },
              {
                id: null,
                type: 'short-text',
                name: 'Profissão da Mãe',
                order: 9,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 4,
                rows: 5
              },
              {
                id: null,
                type: 'short-text',
                name: 'Idade da Mãe',
                order: 10,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 4,
                rows: 5
              },
              {
                id: null,
                type: 'short-text',
                name: 'Escolaridade da Mãe',
                order: 11,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 4,
                rows: 5
              },
              {
                id: null,
                type: 'long-text',
                name: 'Queixa Principal',
                order: 12,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 12,
                rows: 5
              },
              {
                id: null,
                type: 'long-text',
                name: 'Evolução da Queixa',
                order: 13,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 12,
                rows: 5
              },
              {
                id: null,
                type: 'long-text',
                name: 'Foi Repentino ou Casual?',
                order: 14,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 12,
                rows: 5
              },
              {
                id: null,
                type: 'long-text',
                name: 'Quais transformações ocorreram?',
                order: 15,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 12,
                rows: 5
              },
              {
                id: null,
                type: 'long-text',
                name: 'Sintomas',
                order: 16,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 12,
                rows: 5
              },
              {
                id: null,
                type: 'multiple-choice',
                name: 'Queixas Cognitivas',
                order: 17,
                required: false,
                options: 'Integridade Sensorial;Percepção;Atenção;Memória',
                has_default_value: false,
                default_value: '',
                cols: 6,
                rows: 5
              },
              {
                id: null,
                type: 'long-text',
                name: 'Observações',
                order: 18,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 6,
                rows: 9
              },
              {
                id: null,
                type: 'multiple-choice',
                name: 'Queixas Afetivo-Emocional',
                order: 19,
                required: false,
                options: 'Volição;Afeto;Humor;Ansiedade;Medo;Culpa;Raiva;Luto;Desânimo',
                has_default_value: false,
                default_value: '',
                cols: 12,
                rows: 5
              },
              {
                id: null,
                type: 'multiple-choice',
                name: 'Psicomotricidade',
                order: 20,
                required: false,
                options: 'Normal;Lento;Agitado',
                has_default_value: false,
                default_value: '',
                cols: 6,
                rows: 5
              },
              {
                id: null,
                type: 'long-text',
                name: 'Observações',
                order: 21,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 6,
                rows: 7
              },
              {
                id: null,
                type: 'long-text',
                name: 'Hábitos e Rotinas',
                order: 22,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 12,
                rows: 5
              },
              {
                id: null,
                type: 'long-text',
                name: 'Vida Social',
                order: 23,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 12,
                rows: 5
              },
              {
                id: null,
                type: 'long-text',
                name: 'Como está a saúde',
                order: 24,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 12,
                rows: 5
              },
              {
                id: null,
                type: 'long-text',
                name: 'Antecedentes familiares (casos semelhantes na família)',
                order: 25,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 12,
                rows: 5
              },
              {
                id: null,
                type: 'long-text',
                name: 'Histórico Familiar',
                order: 26,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 12,
                rows: 5
              },
              {
                id: null,
                type: 'long-text',
                name: 'Tratamento',
                order: 27,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 12,
                rows: 5
              }
            ]
          },
          {
            name: 'Atendimento Clínico',
            enabled: true,
            fields:[
              {
                id: null,
                type:'short-text',
                name:'NOME DO PACIENTE',
                order:0,
                required:true,
                options: '',
                has_default_value: false,
                default_value: '',
                cols:12,
                rows:5
              },
              {
                id: null,
                type:'short-text',
                name:'IDADE',
                order:1,
                required:false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols:3,
                rows:5
              },
              {
                id: null,
                type:'short-text',
                name:'SEXO',
                order:2,
                required:false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols:3,
                rows:5
              },
              {
                id: null,
                type:'short-text',
                name:'Nº DA SESSÃO',
                order:3,
                required:false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols:3,
                rows:5
              },
              {
                id: null,
                type:'short-text',
                name:'DATA DO ATENDIMENTO',
                order:4,
                required:false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols:3,
                rows:5
              },
              {
                id: null,
                type:'long-text',
                name:'HISTÓRICO E QUEIXA',
                order:5,
                required:false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols:12,
                rows:7
              },
              {
                id: null,
                type:'long-text',
                name:'DESENVOLVIMENTO DA SESSÃO',
                order:6,
                required:false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols:12,
                rows:15
              },
              {
                id: null,
                type:'long-text',
                name:'REFLEXÕES E PERCEPÇÕES DA SESSÃO',
                order:7,
                required:false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols:12,
                rows:15
              },
              {
                id: null,
                type:'long-text',
                name:'REFERÊNCIAS BIBLIOGRÁFICAS',
                order:8,
                required:false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols:12,
                rows:7
              },
              {
                id: null,
                type:'short-text',
                name:'ASSINATURA',
                order:9,
                required:false,
                options: '',
                has_default_value: true,
                default_value:'Assinatura:',
                cols:6,
                rows:5
              }
            ]
          },
          {
            name: 'Exame Físico',
            enabled: true,
            fields: [
              {
                id: null,
                type: 'short-text',
                name: 'Altura (cm)',
                order: 0,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 6,
                rows: 5
              },
              {
                id: null,
                type: 'short-text',
                name: 'Peso (kg)',
                order: 1,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 6,
                rows: 5
              },
              {
                id: null,
                type: 'short-text',
                name: 'Frequência cardíaca (bpm)',
                order: 2,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 4,
                rows: 5
              },
              {
                id: null,
                type: 'short-text',
                name: 'Pressão arterial sistólica (mmHg)',
                order: 3,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 4,
                rows: 5
              },
              {
                id: null,
                type: 'short-text',
                name: 'Pressão arterial diastólica (mmHg)',
                order: 4,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 4,
                rows: 5
              },
              {
                id: null,
                type: 'long-text',
                name: 'Observações gerais',
                order: 5,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 12,
                rows: 5
              },
            ]
          },
          {
            name: 'Hipótese Diagnóstica',
            enabled: true,
            fields: [
              {
                id: null,
                type: 'short-text',
                name: 'Diagnóstico',
                order: 0,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 12,
                rows: 5
              },
              {
                id: null,
                type: 'long-text',
                name: 'Observações',
                order: 1,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 12,
                rows: 5
              },
            ]
          },
          {
            name: 'Evolução',
            enabled: true,
            fields: [
              {
                id: null,
                type: 'long-text',
                name: 'Evolução',
                order: 0,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 12,
                rows: 5
              },
            ]
          },
          {
            name: 'Atestado',
            enabled: true,
            fields: [
              {
                id: null,
                type: 'long-text',
                name: 'Atestado',
                order: 0,
                required: false,
                options: '',
                has_default_value: true,
                default_value: 'Atesto para os devidos fins a pedido do interessado que _______, portador do documento de identidade _______, foi submetido à consulta médica nesta data. \n' +
                  '\n' +
                  'Em decorrência, deverá permanecer afastado de suas atividades laborativas por um período de _______ dias a partir desta data.',
                cols: 12,
                rows: 5
              },
            ]
          },
          // {
          //   name: 'Atestado com CID',
          //   enabled: true,
          //   fields: [
          //     {
          //       id: null,
          //       type: 'long-text',
          //       name: 'Atestado',
          //       order: 0,
          //       required: false,
          //       options: '',
          //       has_default_value: true,
          //       default_value: 'Atesto para os devidos fins a pedido do interessado que _______, portador do documento de identidade _______ foi submetido à consulta médica nesta data, sendo portador de afecção CID-10 ___________________. \n' +
          //         '\n' +
          //         'Em decorrência, deverá permanecer afastado de suas atividades laborativas por um período de _______ dias a partir desta data.',
          //       cols: 12,
          //       rows: 5
          //     },
          //   ]
          // },
          {
            name: 'Atestado com CID',
            enabled: true,
            fields: [
              {
                id: null,
                type: 'short-text',
                name: 'Horário de chegada:',
                order: 0,
                required: true,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 3,
                rows: 5
              },
              {
                id: null,
                type: 'short-text',
                name: 'Horário de saída:',
                order: 1,
                required: true,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 3,
                rows: 5
              },
              {
                id: null,
                type: 'multiple-choice',
                name: 'Compareceu a essa clínica para:',
                order: 2,
                required: false,
                options: 'CONSULTA;REALIZAR EXAMES;RETIRAR EXAMES;FISIOTERAPIA',
                has_default_value: false,
                default_value: '',
                cols: 12,
                rows: 5
              },
              {
                id: null,
                type: 'short-text',
                name: 'OUTROS PROCEDIMENTOS',
                order: 3,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 12,
                rows: 5
              },
              {
                id: null,
                type: 'short-text',
                name: 'ACOMPANHAR FAMILIAR/PACIENTE:',
                order: 4,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 12,
                rows: 5
              },
              {
                id: null,
                type: 'multiple-choice',
                name: 'Outrossim, comunico que:',
                order: 5,
                required: false,
                options: 'NADA APRESENTA QUE IMPOSSIBILITE AO TRABALHO;DEVERÁ PERMANECER EM REPOUSO NO HORÁRIO ACIMA;DEVERÁ PERMANECER EM REPOUSO NO PERÍODO DA MANHÃ;DEVERÁ PERMANECER EM REPOUSO NO PERÍODO DA TARDE;DEVERÁ PERMANECER EM REPOSUO NO DIA DE HOJE',
                has_default_value: false,
                default_value: '',
                cols: 12,
                rows: 5
              },
              {
                id: null,
                type: 'multiple-choice',
                name: 'Outrossim, comunico que:',
                order: 6,
                required: false,
                options: 'DEVERÁ PERMANECER EM REPOUSO POR UM PERÍODO DE',
                has_default_value: false,
                default_value: '',
                cols: 9,
                rows: 5
              },
              {
                id: null,
                type: 'short-text',
                name: 'Dias:',
                order: 7,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 3,
                rows: 5
              },
              {
                id: null,
                type: 'multiple-choice',
                name: 'Outrossim, comunico que:',
                order: 8,
                required: false,
                options: 'OUTROS',
                has_default_value: false,
                default_value: '',
                cols: 3,
                rows: 5
              },
              {
                id: null,
                type: 'short-text',
                name: 'INDICAÇÃO',
                order: 9,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 9,
                rows: 5
              },
              {
                id: null,
                type: 'short-text',
                name: 'Autorização:',
                order: 10,
                required: false,
                options: '',
                has_default_value: true,
                default_value: 'Autorizo o médico assistente a registrar o código CID (Classificação Internacional de Doenças) neste relatório de atendimento médico.',
                cols: 12,
                rows: 5
              },
              {
                id: null,
                type: 'short-text',
                name: 'Codigo:',
                order: 11,
                required: false,
                options: '',
                has_default_value: true,
                default_value: 'CID:',
                cols: 3,
                rows: 5
              },
              {
                id: null,
                type: 'short-text',
                name: 'Assinatura:',
                order: 12,
                required: false,
                options: '',
                has_default_value: true,
                default_value: 'Paciente:',
                cols: 9,
                rows: 5
              },
              {
                id: null,
                type: 'short-text',
                name: 'Assinatura e carimbo do profissional:',
                order: 13,
                required: false,
                options: '',
                has_default_value: true,
                default_value: 'Médico:',
                cols: 6,
                rows: 5
              },
              {
                id: null,
                type: 'short-text',
                name: 'Cidade e data (dia de mês de ano)',
                order: 14,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 6,
                rows: 5
              }
            ]
          },
          {
            name: 'Triagem COVID-19',
            enabled: true,
            fields: [
              {
                id: null,
                type: 'short-text',
                name: 'Temperatura ºC',
                order: 0,
                required: true,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 4,
                rows: 5
              },
              {
                id: null,
                type: 'short-text',
                name: 'Saturação de O²',
                order: 1,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 4,
                rows: 5
              },
              {
                id: null,
                type: 'short-text',
                name: 'BPM',
                order: 2,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 4,
                rows: 5
              },
              {
                id: null,
                type: 'multiple-choice',
                name: 'Sinais e Sintomas',
                order: 3,
                required: false,
                options: 'Febre;Diarréia;Dor de garganta;Dificuldade de deglutir;Crises na coluna;Dores no corpo;Dor nas articulações;Coriza ou nariz entupido;Cefaléia;Cansaço (Mal estar);Falta de ar',
                has_default_value: false,
                default_value: '',
                cols: 4,
                rows: 5
              },
              {
                id: null,
                type: 'multiple-choice',
                name: 'Dificuldade respiratória',
                order: 4,
                required: false,
                options: 'Leve;Moderada;Severa',
                has_default_value: false,
                default_value: '',
                cols: 4,
                rows: 5
              },
              {
                id: null,
                type: 'multiple-choice',
                name: 'Dificuldade respiratória',
                order: 5,
                required: false,
                options: 'Seca;Produtiva',
                has_default_value: false,
                default_value: '',
                cols: 4,
                rows: 5
              },
              {
                id: null,
                type: 'multiple-choice',
                name: 'Viajou para algum lugar nos últimos 14 dias?',
                order: 6,
                required: false,
                options: 'Sim;Não',
                has_default_value: false,
                default_value: '',
                cols: 6,
                rows: 5
              },
              {
                id: null,
                type: 'short-text',
                name: 'Se SIM, qual?',
                order: 7,
                required: false,
                options: 'Sim;Não',
                has_default_value: false,
                default_value: '',
                cols: 6,
                rows: 5
              },
              {
                id: null,
                type: 'long-text',
                name: 'Evolução de enfermagem',
                order: 8,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 12,
                rows: 10
              },
              {
                id: null,
                type: 'long-text',
                name: 'Evolução médica',
                order: 9,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 12,
                rows: 10
              },
            ]
          },
          {
            name: 'Encaminhamento',
            enabled: true,
            fields: [
              {
                id: null,
                type: 'short-text',
                name: 'DE:',
                order: 0,
                required: true,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 6,
                rows: 5
              },
              {
                id: null,
                type: 'short-text',
                name: 'PARA:',
                order: 1,
                required: true,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 6,
                rows: 5
              },
              {
                id: null,
                type: 'long-text',
                name: 'Encaminhamento:',
                order: 2,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 12,
                rows: 40
              }
            ]
          },
          {
            name: 'Receituário',
            enabled: true,
            fields: [
              {
                id: null,
                type: 'long-text',
                name: 'Receituário:',
                order: 0,
                required: false,
                options: '',
                has_default_value: false,
                default_value: '',
                cols: 12,
                rows: 40
              }
            ]
          }
        ]
      }
    },
    mounted () {
      this.canSee = (this.helpers.isOwner())?true:this.helpers.checkPermission('forms', 'can_see');
      this.canAdd = (this.helpers.isOwner())?true:this.helpers.checkPermission('forms', 'can_add');
      this.canEdit = (this.helpers.isOwner())?true:this.helpers.checkPermission('forms', 'can_edit');
      this.canRemove = (this.helpers.isOwner())?true:this.helpers.checkPermission('forms', 'can_remove');

      if(this.canSee == false) {
        this.$swal('Desculpe', 'Você não tem permissão para acessar este módulo!', 'error');
        this.$router.push({ path: '/' }).catch(() => {});
        return;
      }

      this.eventBus.$emit('IS_LOADING', true);
      this.models = this.models.concat([], this.defaultModels);

      this.getForms();
    },
    methods: {
      getForms() {
        this.api.getForms().then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          if(this.leavingPage) {
            return;
          }
          this.forms = res.data.forms;
          this.models = this.defaultModels.concat([], res.data.models);

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Forms', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          if(this.leavingPage) {
            return;
          }
          this.$swal('Ops...', 'Não conseguimos carregar os seus modelos de prontuários! Por favor, entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Forms', err.response);
        });
      },

      getExtension(formName) {
        return formName.split(/\s/).reduce((response,word) => response += word.slice(0,1),'').toUpperCase();
      },

      showModel(model) {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;

        this.modelSelected = model;
        this.$bvModal.show('model-modal');
        this.canPerformAction = true;
      },

      resetModelModal() {
        this.modelSelected = null;
      },

      useSelectedModel() {
        this.api.storeForm(this.modelSelected).then(res => {
          this.canPerformAction = true;
          if(this.leavingPage) {
            return;
          }

          if (res.status == 201) {
            this.getForms();
            this.$bvModal.hide('model-modal');

            this.$swal('Uhull \\o/', 'O modelo de prontuário foi importado com sucesso!', 'success');
          } else {
            this.$swal('Ops...', 'Ocorreu um erro ao importar o modelo de prontuário! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
          }

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Store Form', res);
        }).catch(err => {
          this.canPerformAction = true;
          if(this.leavingPage) {
            return;
          }

          let msg = 'Não conseguimos importar este modelo de prontuário! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

          switch (err.response.status) {
            case 422: msg = err.response.data.errors.join('\r\n'); break;
          }

          this.$swal('Ops...', msg, 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Store Form', err.response);
        });
      },

      deleteSelectedModel() {
        this.$swal({
          title: 'Você tem certeza?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Remover modelo',
          cancelButtonText: 'Cancelar',
          focusCancel: true
        }).then((res) => {
          if(res.value) {
            this.canPerformAction = false;
            this.eventBus.$emit('IS_LOADING', true);
            this.api.deleteForm(this.modelSelected.id).then(res => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;
              if (res.status == 204) {
                let index = this.models.indexOf(this.modelSelected);
                this.models.splice(index, 1);
                this.modelSelected = null;

                this.$bvModal.hide('model-modal');

                this.$swal('Uhull \\o/', 'O modelo de formulário foi excluído com sucesso!', 'success');
              } else {
                this.$swal('Ops...', 'Ocorreu um erro ao excluir o modelo de formulário! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error')
              }

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Response Delete Form', res);
            }).catch(err => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;
              this.$swal('Ops...', 'Não conseguimos excluir este modelo de formulário! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error Delete Form', err.response);
            });
          }
        });
      }
    },
    beforeRouteLeave (to, from, next) {
      this.leavingPage = true;
      next();
    }
  }
</script>

<style lang="scss">
  .form-config-list {
    padding: 20px 0;

    .box-cj {
      .icon {
        width: 92px;
        height: 113px;
        background: url(../../assets/images/form_disabled.svg) center center;
        color: $linkWater;
        padding: 30px 20px;
        display: inline-block;
        margin-bottom: 20px;

        &.enabled {
          background: url(../../assets/images/form_enabled.svg) center center;
          color: $pictionBlue;
        }
      }

      .status {
        .enabled {
          color: $ufoGreen;
        }

        color: $cadetGray;
      }
    }
  }
</style>
